/**
 * How many list chips the Lists tab shows before "+N more" — Doug, 17 Oct:
 * "I don't think it makes sense that there's three rows at the top with
 * the chips … Kindred prep is something I rarely use … limit it to two
 * with maybe a more."
 *
 * Not measured in rows: a row depends on the names' widths and on the
 * viewport, and measuring is a layout effect on a cold load (CLAUDE.md,
 * WP 6.9). A count: the first `cap` lists in the order Doug himself sets
 * (`chipOrder` — drag, Move to start / end), which with Shortlist and the
 * "+N" chip is two rows at 390px for his names. The lists he uses most are
 * the ones he put first, so the fold is his order, not a guess about use.
 *
 * The selected list is always shown, wherever it sits in the order: a list
 * opened from the index, a deep link or Today must have a lit chip. It
 * takes the last visible slot rather than a seventh, so the row count holds.
 *
 * Dependency-free (type-only import) for the root suite.
 */
export const CHIP_CAP = 4

export interface ChipFold<L> {
  /** The chips drawn, in order. */
  shown: L[]
  /** The lists behind "+N more"; empty when nothing is folded. */
  hidden: L[]
}

export function chipFold<L extends { id: string }>(ordered: readonly L[], selectedId: string | null, expanded: boolean, cap = CHIP_CAP): ChipFold<L> {
  if (expanded || ordered.length <= cap + 1) return { shown: [...ordered], hidden: [] }
  // `cap + 1`: folding exactly one list behind a "+1" chip saves nothing.
  const shown = ordered.slice(0, cap)
  const rest = ordered.slice(cap)
  const sel = rest.find(l => l.id === selectedId)
  if (!sel) return { shown, hidden: rest }
  const last = shown[shown.length - 1]
  return { shown: [...shown.slice(0, -1), sel], hidden: [last, ...rest.filter(l => l.id !== sel.id)] }
}
